import Modal from '../modules/Modal';
import Migrate, { Props } from '../views/Migrate';

export type { Props as MigrateModalProps };

const MigrateModal = (props: Props) => {
  return (
    <Modal size="2xl" clickOffToClose>
      <div className="pb-4 bg-gray-50">
        <header className="bg-gray-100 px-4 py-3">
          <h2 className="text-base font-medium text-gray-500">
            {'Migrate a position'}
          </h2>
        </header>
        <div className="p-4">
          <Migrate {...props} />
        </div>
      </div>
    </Modal>
  );
};

export default MigrateModal;
